// Media assets (scrapbook collage). All copy now lives in /i18n/translations.js.
const U = (id, w = 1200) =>
  `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${w}&q=72`;

export const IMG = {
  heroVibe: U("1669437959848-911956487cea", 1600),
  nightlife: U("1611631802331-203721f8f510", 1400),
  scrap1: U("1764072363196-fe211d1dcd26", 1000),
  scrap2: U("1602692095694-81c8efb4b020", 1000),
  location:
    "https://images.pexels.com/photos/29798969/pexels-photo-29798969.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
};

// Placeholder UGC clip (loads only on click). Vertical framing handled by the lightbox.
export const SAMPLE_VIDEO =
  "https://storage.googleapis.com/gtv-videos-bucket/sample/ForBiggerJoyrides.mp4";
